import React, { useMemo, useState } from "react";
import BsySelect from "../BsySelect";
import BsyComboBox from "../BsyComboBox";
import { BsyUtils } from "../../utils/Utils";

export const BatchActive = function (props) {
  const { flowVers, datas, onStopEdit } = props;
  const [selectFlows, setSelectFlows] = useState([]);

  const selectFlowsMemo = useMemo(() => {
    return flowVers.map((ver) => {
      let version = parseInt(ver[0]);
      const flows = ver[1]
        .filter((flow) => {
          return flow.type === "cc" || flow.flowId === -1 ? false : true;
        })
        .map((flow) => {
          return {
            text: flow.name,
            value: flow.flowId,
            type: flow.type,
            flowVer: version,
            selected: selectFlows.find(
              (item) => item.flowVer === version && item.flowId === flow.flowId
            )
              ? true
              : false,
          };
        });
      const dataIds = datas
        .filter((data) => {
          if (
            parseInt(data.flowVer) === version &&
            (data.flowState === 1 || data.flowState === 2)
          ) {
            return true;
          }
          return false;
        })
        .map((data) => {
          return { id: data._id, label: data.label };
        });
      //   console.log(dataIds);

      return {
        items: flows,
        dataIds: dataIds,
      };
    });
  }, [selectFlows]);
  console.log(selectFlowsMemo);
  return (
    <div>
      <div className="bsy-batch-active">
        {selectFlowsMemo.map((ver, index) => {
          const { items, dataIds } = ver;

          return (
            <div key={`${items[0].flowVer}-${index}`}>
              <div className="flow-item">
                <span className="bsy-batch-flow-item-title">
                  <span className="bsy-batch-flow-item-title-text-left">
                    {dataIds.filter((item) => !BsyUtils.isObjectEmpty(item.label)).map((item) => item.label).join("、")}
                  </span>
                  <span className="bsy-batch-flow-item-title-text-right">
                    <span className="flow-version">V{items[0].flowVer}</span>
                    <span className="data-count">
                      ({`共${dataIds.length}条数据`})
                    </span>
                  </span>
                </span>
                <div className="bsy-batch-flow-item-content">
                  <BsyComboBox
                    key={"kegyd" + new Date().getTime()}
                    allowBlank={true}
                    searchable={true}
                    height={34}
                    hint={React.language("flow.batch.active.flow.hint")}
                    width={"100%"}
                    items={items}
                    onStopEdit={(val) => {
                      if (BsyUtils.isObjectEmpty(val)) {
                        const d = [
                          ...selectFlows.filter(
                            (item) => item.flowVer !== items[0].flowVer
                          ),
                        ];
                        setSelectFlows(d);
                        onStopEdit?.(d);
                      } else {
                        const d = [
                          ...selectFlows.filter(
                            (item) => item.flowVer !== items[0].flowVer
                          ),
                          {
                            flowVer: items[0].flowVer,
                            flowId: val,
                            dataIds: dataIds,
                          },
                        ];
                        setSelectFlows(d);
                        onStopEdit?.(d);
                      }
                    }}
                  ></BsyComboBox>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
